import { Button } from "@mantine/core";
import "./CertificatesCard.css";
import moment from "moment";
import defaultImage from "../../../assets/Certificate/DefaultCourseCertified.png";
import { IconChalkboard, IconDownload } from "@tabler/icons-react";
import { useContext } from "react";
import AppContext from "../../../contexts/AppContext";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContextProvider";

const CertificatesCard = ({ certificates, handleDownloadClick, setIsModal }) => {
   const { currentUser } = useContext(AppContext);
   const { jsonTexts } = useConfigContext();
   const texts = jsonTexts?.misCertificados?.certificatesCard

   {/*TODO: Change defaultImage certificate*/}
   return (
      <div className="certificatesCard-layout">
         {certificates.map((certificate) => (
            <div className="certificatesCard-father-div">
               <div>
                  <img
                     className="certificatesCard-image"
                     src={certificate.certificatePreview || defaultImage}
                     height={160}
                     alt="Certificates"
                  />
               </div>

               <div className="certificatesCard-infoDiv">
                  <p className="certificatesCard-courseTitle">
                     {certificate.academicUnitName}
                  </p>
                  <p className="certificatesCard-dateText">
                     {moment(certificate.dateOfIssue).format("DD/MM/YYYY")}
                  </p>

                  <Button
                     color="var(--color-tertiary)"
                     fw="normal"
                     fullWidth
                     mt="md"
                     radius="md"
                     onClick={() => {
                        setIsModal(true);
                        const { academicUnitId, download, note } = certificate;
                        handleDownloadClick(academicUnitId, download, note)
                     }}
                  >
                     <IconDownload />
                     <p className="certificatesCard-buttons-textSize">{texts?.downloadButtonText}</p>
                  </Button>
                  <Button
                     classNames={{ root: "certificatesCard-secondButton-root" }}
                     fw="normal"
                     color="var(--color-secondary)"
                     variant="outline"
                     fullWidth
                     mt="md"
                     component="a"
                     target="_blank"
                     href={`/certificaciones/validacion/${currentUser._id}/${certificate.academicUnitId}`}
                  >
                     <IconChalkboard />
                     <p className="certificatesCard-buttons-textSize">{texts?.validationButtonText}</p>
                  </Button>
               </div>
            </div>

         ))}
      </div>
   );
};
export default CertificatesCard;
